import styled from 'styled-components'
import { Button } from '~components'

export const SecondaryButton = styled(Button).attrs({ color: 'subtle', width: '100%' })`
  margin-top: ${({ theme }) => theme.spacing.km1};
`
